<template>
	<div>
		<div class="subheader position-relative">
			<h1 class="text-center text-white position-relative">
                {{ $t("navbar.about") }}
            </h1>
		</div>
        <div class="bg-brown">
            <div class="container p-md-5 p-3">
                <div class="row">
                    <div class="col-12 text-white">
                        <div class="py-3">
                            <p class="text-justify">{{ $t("about.section_one") }}</p>
                            <p class="text-justify">{{ $t("about.section_two") }}</p>
                            <p class="signature">{{ $t("about.signature_one") }}</p>
                        </div>
                    </div>
                    <div class="col-12 slide carousel pb-3 pb-md-0" id="slider_2" data-ride="carousel">
                        <div class="row carousel-inner">
                            <div class="col-md-4 mobile-carousel-item active">
                                <img src="../assets/img/old1.jpg" draggable="false" class="img-fluid goes-black">
                            </div>
                            <div class="col-md-4 mt-3 mt-md-0 mobile-carousel-item">
                                <img src="../assets/img/old2.jpg" draggable="false" class="img-fluid goes-black">
                            </div>
                            <div class="col-md-4 mt-3 mt-md-0 mobile-carousel-item">
                                <img src="../assets/img/old3.jpg" draggable="false" class="img-fluid goes-black">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="bg-vanilla">
            <div class="container p-md-5 p-3">
                <div class="row">
                    <div class="col-12">
                        <div class="py-3">
                            <p>{{ $t("about.section_three") }}</p>
                            <p>{{ $t("about.section_four") }}</p>
                            <p class="signature">{{ $t("about.signature_two") }}</p>
                        </div>
                    </div>
                    <div class="col-12 slide carousel pb-3 pb-md-0" id="slider_2" data-ride="carousel">
                        <div class="row carousel-inner">
                            <div class="col-md-4 mobile-carousel-item active">
                                <img src="../assets/img/new0.jpg" draggable="false" class="img-fluid">
                            </div>
                            <div class="col-md-4 mt-3 mt-md-0 mobile-carousel-item">
                                <img src="../assets/img/new1.jpg" draggable="false" class="img-fluid">
                            </div>
                            <div class="col-md-4 mt-3 mt-md-0 mobile-carousel-item">
                                <img src="../assets/img/new2.jpg" draggable="false" class="img-fluid">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
	</div>
</template>

<script>
	import { Bus }  from "../bus.js";

    export default {
        data: function(){
            return {
                lang: ""
            }
        },
        created: function(){
            this.lang = this.$i18n.locale;
        },
        mounted: function(){
            var self = this;
            Bus.$on("lang", (lang) => {
                if(lang === "hu"){
                    self.lang = "hu";
                }else{
                    self.lang = "en";
                }
            });
            this.checkWindowWidth();
        },
        destroyed() {
            window.removeEventListener("resize", this.checkWindowWidth);
        },
        methods:{
            checkWindowWidth: function(){
                if(window.screen.width < 578){
                    document.querySelectorAll('.mobile-carousel-item').forEach(x=>x.classList.add('carousel-item'))
                    document.querySelectorAll('.carousel-inner').forEach(x=>x.classList.remove('row'))
                }else{
                    document.querySelectorAll('.mobile-carousel-item').forEach(x=>x.classList.remove('carousel-item'))
                    document.querySelectorAll('.carousel-inner').forEach(x=>x.classList.add('row'))
                }
            }
        },
        watch: {
            lang: function(){
                if(this.lang === "hu"){
                    history.pushState('', "Rólunk", "https://ijaszat.eu/rolunk");
                }else{
                    history.pushState('', "About", "https://ijaszat.eu/about");
                }
            }
        },
        metaInfo() {
            return {
                titleTemplate: chunk => (
                    this.lang === 'hu'
                    ? 'Csodaszarvas Íjászbarlang - Rólunk'
                    : 'Csodaszarvas Íjászbarlang - About'
                ),
                meta: [
                    {
                        vmid: 'description',
                        name: 'description',
                        content: this.lang === 'hu' ? '2006 októberében megnyílt a Csodaszarvas Íjászbarlang a Villányi úton. Több mint 15 évnyi tapasztalatot gyúrtunk bele íjaink felépítésébe és kivitelezésébe. Egyesületünk már olimpiai szakággal is rendelkezik.' : 'In October 2006 I opened my own archery shop called Csodaszarvas íjászbarlang in Villányi Street. We’ve put more than 15 years of experience into our bow’s design and implementation. Our archery association now has an Olympic-archery group too.',
                    },
                    {
                        vmid: 'og:description',
                        name: 'og:description',
                        content: this.lang === 'hu' ? '2006 októberében megnyílt a Csodaszarvas Íjászbarlang a Villányi úton. Több mint 15 évnyi tapasztalatot gyúrtunk bele íjaink felépítésébe és kivitelezésébe. Egyesületünk már olimpiai szakággal is rendelkezik.' : 'In October 2006 I opened my own archery shop called Csodaszarvas íjászbarlang in Villányi Street. We’ve put more than 15 years of experience into our bow’s design and implementation. Our archery association now has an Olympic-archery group too.',
                    },
                    {
                        vmid: 'og:title',
                        property: 'og:title',
                        content: this.lang === 'hu' ? 'Csodaszarvas Íjászbarlang - Rólunk' : 'Csodaszarvas Íjászbarlang - About',
                    }
                ]
            };
        }
    };
</script>


// WEBPACK FOOTER //
// src/components/About.vue